import { module } from 'modujs';
import Plyr from 'plyr';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                close: 'close'
            }
        }
    }

    init() {
        this.id = this.el.getAttribute('data-player-id');
        this.playerElt = this.el.querySelector('.c-player_elt');
        this.player = new Plyr(this.playerElt);
        this.opened = false;

        document.querySelectorAll('.c-player_open').forEach((elt) => {
            elt.addEventListener('click', (e) => {
                e.preventDefault();
                this.open(elt.getAttribute('data-player-id'));
            });
        });
    }

    close() {
        this.opened = false;
        this.el.classList.remove('-visible');
        this.call('start','Scroll');

        if (this.player) {
            this.player.pause();
        }
    }

    open(id) {
        if (id != this.id || this.opened) return;

        this.opened = true;
        this.el.classList.add('-visible');
        this.call('stop','Scroll');

        if (this.player) {
            this.player.restart();
            this.player.pause();
            setTimeout(() => {
                this.player.increaseVolume();
                this.player.play();
            }, 1000);
        }
    }
}
